/* =========================================================
   Fun & Sport — Klarna Installments (Global)
   ========================================================= */

function fsFormatCurrency(amount) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(amount);
}

function fsUpdateKlarna(context = document) {
  const elements = context.querySelectorAll(
    '.fs-klarna, .fs-cart-klarna, .fs-drawer-klarna'
  );

  elements.forEach(el => {
    const rawPrice =
      el.getAttribute('data-product-price') ||
      el.getAttribute('data-cart-total');

    const price = parseInt(rawPrice, 10);
    if (isNaN(price)) return;

    const total = price / 100;

    // ✅ HANDLE VISIBILITY HERE
    if (total < 50) {
      el.style.display = 'none';
      return;
    }

    el.style.display = 'block';

    const split = Math.round(price / 3) / 100;

    const span = el.querySelector('.klarna-price');
    if (span) {
      span.innerText = fsFormatCurrency(split);
    }
  });
}

/* -----------------------------
   PDP Variant change (DOM-based)
----------------------------- */
function fsInitVariantListener() {
  document.addEventListener('change', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    setTimeout(() => {
      const priceEl = document.querySelector('.m-price-item--regular, .m-product-price');
      if (!priceEl) return;

      const text = priceEl.textContent.trim();
      const numeric = text.replace(/[^0-9.]/g, '');

      const price = Math.round(parseFloat(numeric) * 100);
      if (isNaN(price)) return;

      const klarnaEl = document.querySelector('.fs-klarna');
      if (!klarnaEl) return;

      // update data attribute
      klarnaEl.setAttribute('data-product-price', price);

      // reuse your existing function
      fsUpdateKlarna();

    }, 100);
  });
}

/* -----------------------------
   Initial load
----------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  fsUpdateKlarna();
  fsInitVariantListener(); // 👈 add this
});

/* -----------------------------
   Cart updates (Minimog)
----------------------------- */
document.addEventListener('cart:updated', () => {
  fsUpdateKlarna();
});
